if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomControl = this.querySelector('[data-nv-zoom]');
        this.zoomControl?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.zoomControl?.addEventListener('click', (event) => {
          event.stopPropagation();
          const enlarged = this.classList.toggle('nv-cx-enlarged');
          this.zoomControl.setAttribute('aria-pressed', String(enlarged));
          this.zoomControl.textContent = enlarged ? this.zoomControl.dataset.labelFit : this.zoomControl.dataset.labelEnlarge;
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = 0;
          container.scrollTop = 0;
        });
      }

      hide() {
        this.clearModalImageStatus();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.classList.remove('nv-cx-enlarged');
        if (this.zoomControl) {
          this.zoomControl.setAttribute('aria-pressed', 'false');
          this.zoomControl.textContent = this.zoomControl.dataset.labelEnlarge;
        }
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.showModalImageStatus(activeMedia);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;
        container.scrollTop = 0;
        if (this.zoomControl) this.zoomControl.hidden = activeMedia.tagName !== 'IMG';

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
      showModalImageStatus(image) {
        this.clearModalImageStatus();
        if (image?.tagName !== 'IMG' || (image.complete && image.naturalWidth > 0)) return;
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;
        const status = document.createElement('span');
        status.className = 'nv-cx-modal-image-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        dialog.append(status);
        status.textContent = this.dataset.imageLoadingLabel || 'Loading image…';
        const onLoad = () => {
          if (this.modalImageStatus?.image === image) this.clearModalImageStatus();
        };
        const onError = () => {
          if (this.modalImageStatus?.image !== image) return;
          image.removeEventListener('load', onLoad);
          image.removeEventListener('error', onError);
          status.textContent = this.dataset.imageErrorLabel || 'Image unavailable. Close and try another image.';
        };
        this.modalImageStatus = { image, status, onLoad, onError };
        image.addEventListener('load', onLoad, { once: true });
        image.addEventListener('error', onError, { once: true });
        if (image.complete && image.naturalWidth > 0) onLoad();
        else if (image.complete && image.currentSrc && image.naturalWidth === 0) onError();
      }

      clearModalImageStatus() {
        const state = this.modalImageStatus;
        if (!state) return;
        state.image.removeEventListener('load', state.onLoad);
        state.image.removeEventListener('error', state.onError);
        state.status.remove();
        this.modalImageStatus = null;
      }
    }
  );
}
